/**
 * Replaces every `{key}` placeholder in a translated template with its value.
 */
export function fillTemplate(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  );
}

/**
 * Whether to warn that a Dataverse source's tables will queue: the source is Dataverse, a limit is
 * configured (zero means no limit), and more tables are involved than the limit allows at once.
 */
export function exceedsDataverseCapacity(sourceType: string, limit: number, tableCount: number): boolean {
  return sourceType === 'Dataverse' && limit > 0 && tableCount > limit;
}

/**
 * Formats a count taken from paged results, marking it open-ended ("100+") when more results exist
 * beyond those loaded.
 */
export function formatOpenEndedCount(count: number, hasMore: boolean): string {
  return hasMore ? `${String(count)}+` : String(count);
}
